module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('section', [_vm._m(0), _c('h1', [_vm._v(_vm._s(_vm.$route.meta.title))]), _vm._m(1)]), _c('programList'), _c('div', {
    staticClass: "mb-40"
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-decoration"
  }, [_c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center",
    staticStyle: {
      "margin-bottom": "32px"
    }
  }, [_vm._v("WirForce 期間，4Gamers 安排了各種比賽與活動，不管你是否到場參加，都別忘了密切關注以下節目表，若你真的無法到場同樂，也別忘了鎖定 4Gamers 的 Twitch 頻道"), _c('br'), _c('br'), _c('span', [_vm._v("《主舞台》")]), _c('a', {
    staticClass: "link-red",
    attrs: {
      "href": "https://www.twitch.tv/wirforce",
      "target": "_blank"
    }
  }, [_vm._v("https://www.twitch.tv/wirforce")]), _c('br'), _c('span', [_vm._v("《BYOC 舞台》")]), _c('a', {
    staticClass: "link-red",
    attrs: {
      "href": "https://www.twitch.tv/wirforce_byoc",
      "target": "_blank"
    }
  }, [_vm._v("https://www.twitch.tv/wirforce_byoc")]), _c('br'), _c('br'), _vm._v("我們也會宣導在 byoc 的實況主加入以下 team，讓所有在 "), _c('a', {
    staticClass: "link-red",
    attrs: {
      "href": "https://www.twitch.tv/team/wirforce",
      "target": "_blank"
    }
  }, [_vm._v("WirForce 的直播集")]), _vm._v(" 中宣傳！")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd06f44a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/highlights.vue
// module id = 588
// module chunks = 1